import { Component, OnInit, ChangeDetectorRef } from "@angular/core";

import { ActivatedRoute } from "@angular/router";

import { ItemService } from "core/items/items.service";
import { NoteService } from "core/notes/notes.service";

@Component({
	selector: "kt-item-notes",
	templateUrl: "./item-notes.component.html",
	styleUrls: ["./item-notes.component.scss"],
})
export class ItemNotesComponent implements OnInit {
	item: any;
	notes: any[] = [];
	error: string = null;

	constructor(
		private route: ActivatedRoute,
		private change: ChangeDetectorRef,
		private itemService: ItemService,
		private noteService: NoteService
	) { }

	ngOnInit() {
		this.route.parent.paramMap.subscribe((params) => {
			let itemId = Number.parseInt(params.get("itemID"));
			Promise.all([
				this.itemService
					.getItem(itemId)
					.then((item: any) => (this.item = item)),
				this.noteService
					.listByItem(itemId)
					.then((notes: any[]) => (this.notes = notes)),
			])
				.catch((error: any) => (this.error = error.error))
				.then(() => {
					this.change.detectChanges();
				});
		});
	}
}
